<template>
  <div class="home">
    <div class="content-wrapper">
      <!-- 顶部 Tab 切换 -->
      <div class="tab-container">
        <div
          class="tab-item"
          :class="{ active: isChooseLeft }"
          @click="isChooseLeft = true"
        >
          领取地铁票
        </div>
        <div
          class="tab-item"
          :class="{ active: !isChooseLeft }"
          @click="goToCardList"
        >
          票卡列表
        </div>
      </div>

      <!-- 主内容区域 -->
      <div class="main-card">
        <div v-show="isChooseLeft">
          <van-form @submit="onSubmit" ref="form">

            <!-- 1. 活动选择 (核心改造点) -->
            <van-field
              readonly
              center
              clickable
              name="activity"
              :value="selectedActivityName"
              label="活动列表"
              placeholder="点击选择活动"
              right-icon="arrow"
              @click="showActivityPicker = true"
              :rules="[{ required: true, message: '请选择活动' }]"
            />

            <!-- 2. 兑换码输入 -->
            <van-field
              v-model="form.InputCode"
              name="code"
              label="兑换码"
              center
              placeholder="请输入兑换码"
              :rules="[{ required: true, message: '请输入兑换码' }]"
            />

            <!-- 协议 -->
            <div class="agreement">
              领取代表您已同意
              <a href="https://ucityapp.xzsmartmetro.com/v1.1.9/XZmetro_app_H5/source/mouldboard/Agreement.html">《徐州地铁用户协议》</a>
            </div>

            <!-- 提交按钮 -->
            <div class="submit-btn-box">
              <van-button round block type="danger" native-type="submit" :loading="loading">
                立即领取
              </van-button>
            </div>
          </van-form>
        </div>

        <!-- 占位，如果右侧Tab有内容可放这里 -->
        <div v-show="!isChooseLeft" class="empty-placeholder">
          正在跳转...
        </div>
      </div>
    </div>

    <!-- 3. 活动选择弹窗 (带搜索功能) -->
    <van-popup v-model="showActivityPicker" position="bottom" round :style="{ height: '70%' }">
      <div class="picker-content">
        <!-- 搜索栏 -->
        <van-search
          v-model="searchKeyword"
          placeholder="输入关键词搜索活动"
          shape="round"
          show-action
          left-icon=""
          @cancel="showActivityPicker = false"
        />

        <!-- 活动列表 -->
        <div class="activity-list">
          <van-empty v-if="filteredActivityList.length === 0" description="未找到相关活动" />
          <van-cell
            v-for="item in filteredActivityList"
            :key="item.guidAcivity"
            :title="item.Name"
            clickable
            @click="onConfirmActivity(item)"
          >
            <template #right-icon>
              <van-icon name="success" color="#ee0a24" v-if="form.GuidActivity === item.guidAcivity" />
            </template>
          </van-cell>
        </div>
      </div>
    </van-popup>

  </div>
</template>

<script>
import util from '../utils/util'

export default {
  data () {
    return {
      isChooseLeft: true,
      loading: false,

      // 表单数据
      form: {
        InputCode: '',
        GuidActivity: ''
      },
      selectedActivityName: '', // 用于显示在输入框的文字

      // 弹窗与搜索控制
      showActivityPicker: false,
      searchKeyword: '',
      activityList: [] // 原始数据
    }
  },
  computed: {
    // 实时过滤活动列表
    filteredActivityList () {
      let result = []

      // 1. 先处理过滤逻辑
      if (!this.searchKeyword) {
        result = this.activityList
      } else {
        result = this.activityList.filter(item =>
          item.Name && item.Name.toLowerCase().includes(this.searchKeyword.toLowerCase())
        )
      }

      // 2. 返回倒序结果
      return [...result].reverse()
    }
  },
  beforeMount () {
    // 保持原有逻辑：如果是某种奖励类型，直接跳转
    if (this.$store.state.Token && this.$store.state.activityDetail && this.$store.state.activityDetail.RewardType === 2) {
      this.goToCardList()
    }
  },
  mounted () {
    this.getActivityList()
  },
  methods: {
    // 跳转逻辑
    goToCardList () {
      this.$router.push({ path: '/cardslist', query: this.$route.query })
    },

    // 选中活动
    onConfirmActivity (item) {
      this.form.GuidActivity = item.guidAcivity
      this.selectedActivityName = item.Name
      this.showActivityPicker = false
      this.searchKeyword = '' // 可选：选中后清空搜索
    },

    // 获取活动列表
    getActivityList () {
      this.$axios.post('/tp/api/activity/alllistwithcode', {})
        .then(data => {
          if (data && data.Code === 200) {
            this.activityList = data.Data.Items || []
          } else {
            this.$toast(data.Message || '获取活动列表失败')
          }
        })
        .catch(e => {
          console.error(e)
          this.$toast('网络请求失败')
        })
    },

    // 提交表单
    onSubmit () {
      this.loading = true
      // 埋点
      if (util.addmatomo) {
        util.addmatomo('qrcode_myticket_exchange_submit_click_event', 'qrcode_myticket_exchange_submit_click_event', 1)
      }

      this.$axios.post('/itps/api/coupon/appreward', {
        InputCode: this.form.InputCode,
        GuidActivity: this.form.GuidActivity
      })
        .then(data => {
          if (data && data.Code === 200) {
            const guid = data.Data.GuidCoupon
            this.$dialog.alert({
              title: '提示',
              message: '兑换成功！'
            }).then(() => {
              let q = { ...this.$route.query, guid: guid }
              this.$router.push({ path: '/preview', query: q })
            })
          } else {
          // 统一错误处理
            const errorMap = {
              '-404': '网络错误',
              '4731': '兑换码错误',
              '4732': '活动已失效',
              '4733': '优惠券已失效',
              '4734': '优惠券已领取',
              '4736': '必须选择活动'
            }
            this.$toast(errorMap[data.Code] || data.Message)
          }
        })
        .catch(error => {
          console.error(error)
          this.$toast('请求异常')
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
/* 页面整体背景 */
.home {
  min-height: 100vh;
  background-image: url(/img/bg_all.png); /* 保持原有背景 */
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-color: #a43f3f; /* 保持原有底色 */
  padding-top: 90px; /* 保持原有顶部留白 */
  box-sizing: border-box;
}

.content-wrapper {
  width: 90%;
  margin: 0 auto;
}

/* Tab 样式模拟 */
.tab-container {
  display: flex;
  height: 50px;
  align-items: flex-end;
}

.tab-item {
  flex: 1;
  height: 42px;
  line-height: 42px;
  text-align: center;
  font-size: 15px;
  font-weight: bold;
  cursor: pointer;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  transition: all 0.3s;

  /* 默认未选中样式 (深红) */
  background-color: #a21f1f;
  color: rgba(255, 255, 255, 0.8);
}

.tab-item.active {
  height: 50px; /* 选中变高 */
  line-height: 50px;
  background-color: #F4F8FF; /* 选中变白 */
  color: #454545;
  font-size: 17px;
}

/* 主卡片区域 */
.main-card {
  background-color: #F4F8FF;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  padding: 20px 15px;
  min-height: 200px;
}

/* 覆盖 Vant 默认样式以匹配设计 */
.van-cell {
  background-color: transparent;
  padding-left: 0;
  padding-right: 0;
}

/* 输入框样式微调 */
::v-deep .van-field__label {
  width: 70px;
  color: #7f92a5;
  font-size: 14px;
}

::v-deep .van-field__value {
  background-color: #fff;
  padding: 5px 10px;
  border-radius: 6px;
  border: 1px solid #c1cdd9;
}

::v-deep .van-cell::after {
  border-bottom: none; /* 去除下划线 */
}

.agreement {
  text-align: center;
  font-size: 12px;
  color: #7F92A5;
  margin: 20px 0;
}

.agreement a {
  color: #a21f1f;
}

.submit-btn-box {
  margin-top: 10px;
}

/* 按钮渐变色 */
.van-button--danger {
  background: #a21f1f;
  border: none;
  border-radius: 5px;
}

/* 弹窗内部样式 */
.picker-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.activity-list {
  flex: 1;
  overflow-y: auto;
}

.van-search__content {
  background-color: #ffffff;
}
</style>
